import styled from "@emotion/styled";
import { Button } from "@mui/material";
import { ZIndexLevels } from "../geoUtils";

const BUTTON_SIZE = "30px";
export const BORDER_STYLE = "1px solid black";

/**
 * A styled button with custom styles.
 */
export const StyledButton = styled( Button )( {
    backgroundColor: "white",
    border: "1px solid grey",
    borderRadius: "10px",
    minWidth: BUTTON_SIZE,
    minHeight: BUTTON_SIZE,
    width: BUTTON_SIZE,
    height: BUTTON_SIZE,
    margin: "5px",
    padding: "2px",
    fontFamily: "Courier monospace",
    fontSize: "24px",
    lineHeight: "1.5",
    "@media (hover: hover) and (pointer: fine)": {
        "&:hover": {
            backgroundColor: "lightgrey",
        },
    },
} );

/**
 * A styled button with custom styles for the left half of a button group.
 */
export const StyledButtonLeftHalf = styled( Button )( {
    backgroundColor: "white",
    border: "1px solid grey",
    borderTopLeftRadius: "10px",
    borderBottomLeftRadius: "10px",
    borderTopRightRadius: "0",
    borderBottomRightRadius: "0",
    minWidth: BUTTON_SIZE,
    minHeight: BUTTON_SIZE,
    width: BUTTON_SIZE,
    height: BUTTON_SIZE,
    padding: "2px",
    margin: "5px 0 5px 5px",
    "&:hover": {
        backgroundColor: "lightgrey",
    },
} );

/**
 * A styled button with custom styles for the Middle half of a button group.
 */
export const StyledButtonMiddle = styled( Button )( {
    backgroundColor: "white",
    border: "1px solid grey",
    minWidth: BUTTON_SIZE,
    minHeight: BUTTON_SIZE,
    width: BUTTON_SIZE,
    height: BUTTON_SIZE,
    padding: "2px",
    margin: "5px 0 5px 0px",
    "&:hover": {
        backgroundColor: "lightgrey",
    },
} );

/**
 * A styled button with custom styles for the right half of a button group.
 */
export const StyledButtonRightHalf = styled( Button )( {
    backgroundColor: "white",
    border: "1px solid grey",
    borderTopLeftRadius: "0",
    borderBottomLeftRadius: "0",
    borderTopRightRadius: "10px",
    borderBottomRightRadius: "10px",
    minWidth: BUTTON_SIZE,
    minHeight: BUTTON_SIZE,
    width: BUTTON_SIZE,
    height: BUTTON_SIZE,
    padding: "2px",
    margin: "5px 5px 5px 0",
    "&:hover": {
        backgroundColor: "lightgrey",
    },
} );

/**
 * A container for overlapping elements.
 */
export const OverlappingElementsContainer = styled( "div" )( {
    position: "relative",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
} );

export const doNotForwardIsMobileOrRightBarExpanded = ( prop: string ) => prop !== "isMobile" && prop !== "isRightBarExpanded" && prop !== "isShowingAlerts";

/**
 * A container for additional actions with responsive flex direction based on device type.
 * @param isMobile - Boolean indicating if the device is mobile.
 */
export const AdditionalActionsContainer = styled( "div", { shouldForwardProp: doNotForwardIsMobileOrRightBarExpanded } )<{ isMobile: boolean, isRightBarExpanded: boolean, isShowingAlerts: boolean }>( ( { isMobile, isRightBarExpanded, isShowingAlerts } ) => ( {
    position: "absolute",
    display: "flex",
    flexDirection: isMobile ? "column" : "row",
    border: BORDER_STYLE,
    borderRadius: "10px",
    background: "white",
    bottom: isMobile ? "100px" : ( isShowingAlerts ? "10px" : "70px" ),
    right: isMobile ? "10px" : ( isRightBarExpanded ? "340px" : "16px" ),
    zIndex: ZIndexLevels.BeneathDrawerUiElement,
    transition: "bottom 0.3s ease, right 0.3s ease",
} ) );

